import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { BsInfoCircle } from "react-icons/bs";

/** Shown next to Department labels on embed form list / editor. */
export const EMBED_DEPARTMENT_TOOLTIP =
    "Options are your workspace departments from the Departments page in the sidebar. Each embed form is assigned to one department; tickets submitted through the form are created in that department.";

/**
 * @param {{ id: string, text?: string, className?: string }} props
 */
export function EmbedDepartmentLabelHint({ id, text = "Department", className = "" }) {
    return (
        <span className={`d-inline-flex align-items-center gap-1 ${className}`.trim()}>
            {text}
            <OverlayTrigger
                placement="bottom"
                flip={false}
                container={
                    typeof document !== "undefined" ? document.body : undefined
                }
                popperConfig={{
                    modifiers: [
                        { name: "flip", enabled: false },
                        {
                            name: "preventOverflow",
                            options: { padding: 8, altAxis: true },
                        },
                    ],
                }}
                overlay={
                    <Tooltip
                        id={id}
                        className="embed-department-label-hint-tooltip"
                    >
                        {EMBED_DEPARTMENT_TOOLTIP}
                    </Tooltip>
                }
            >
                <span
                    className="embed-department-label-hint"
                    role="img"
                    aria-label={EMBED_DEPARTMENT_TOOLTIP}
                    tabIndex={0}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                >
                    <BsInfoCircle aria-hidden size={14} />
                </span>
            </OverlayTrigger>
        </span>
    );
}

export default EmbedDepartmentLabelHint;
